import createHistory from 'history/createBrowserHistory';
const history = createHistory({ basename: "chinalcop" });
//const history = createHistory({ basename: "quellaveco" });
//const history = createHistory();
export default history;
